import { Box } from "@mui/material";
import { Color, FontStyle, Inputs } from "../constants";

export const MainButton = ({
  disableGrow = false,
  children,
  sx = null,
  disabled = false,
  ...props
}) => {
  return (
    <Box
      sx={{
        // ...FontStyle.styledButton,
        ...FontStyle.headingBody,
        backgroundColor: Color.deepPurple,
        borderRadius: Inputs.borderRadius,
        py: Inputs.py,
        px: Inputs.px,
        textAlign: "center",
        cursor: "pointer",
        transition: "all 0.25s ease-in-out",
        letterSpacing: "0px",
        color: "white",
        "&:hover": {
          backgroundColor: Color.deeperPurple,
          // backgroundColor: Color.samDarkBlue,
          letterSpacing: disableGrow ? "0px" : "1.05px",
        },
        transition:
          "background-color 0.2s ease-in-out, letter-spacing 0.2s ease-in-out",
        ...(disabled && {
          backgroundColor: Color.deepPurple + "80",
          cursor: "default",
          "&:hover": {
            backgroundColor: Color.deepPurple + "80",
            letterSpacing: "0px",
          },
        }),
        ...sx,
      }}
      {...props}>
      {children}
    </Box>
  );
};
export const SecondaryButton = ({
  outlined = false,
  children,
  sx = null,
  ...props
}) => {
  return (
    <Box
      sx={{
        // ...FontStyle.styledButton,
        ...FontStyle.headingBody,
        color: Color.deepPurple,
        backgroundColor: "transparent",
        borderRadius: Inputs.borderRadius,
        py: Inputs.py,
        px: Inputs.px,
        textAlign: "center",
        cursor: "pointer",
        transition: "all 0.25s ease-in-out",
        letterSpacing: "0px",
        ...(outlined && {
          border: `0.5px solid ${Color.deepPurple}`,
        }),
        "&:hover": {
          backgroundColor: Color.deepPurple + "20",
          // backgroundColor: Color.samDarkBlue,
          // letterSpacing: "1px",
        },
        transition:
          "background-color 0.25s ease-in-out, letter-spacing 0.25s ease-in-out",
        ...sx,
      }}
      {...props}>
      {children}
    </Box>
  );
};
export const GrayButton = ({ children, sx = null, ...props }) => {
  return (
    <Box
      sx={{
        ...FontStyle.headingBody,
        backgroundColor: Color.bgLight,
        borderRadius: Inputs.borderRadius,
        py: Inputs.py,
        px: Inputs.px,
        textAlign: "center",
        cursor: "pointer",
        transition: "all 0.25s ease-in-out",
        letterSpacing: "0px",
        color: "#0008",
        "&:hover": {
          backgroundColor: Color.bgMed,
          // backgroundColor: Color.samDarkBlue,
          // letterSpacing: "1.05px",
          color: "#000d",
        },
        transition:
          "background-color 0.2s ease-in-out, letter-spacing 0.2s ease-in-out, color 0.2s ease-in-out",
        ...sx,
      }}
      {...props}>
      {children}
    </Box>
  );
};
